import React from "react";
import {
  Wrapper,
  Title,
  Body,
  Column,
  ColumnTitle,
  ColumnValue,
} from "./styles/box-styles";
import Candidate from "../../apiResources/Candidate";

const PersonalInfo = (props: Props) => {
  const { candidate } = props;
  return (
    <Wrapper className="animated delay-1 fadeIn">
      <Title>Personal Information</Title>
      <Body>
        <Column>
          <ColumnTitle>Full Name</ColumnTitle>
          <ColumnValue>{candidate.fullName}</ColumnValue>
        </Column>
        <Column>
          <ColumnTitle>Phone</ColumnTitle>
          <ColumnValue>{candidate.contactNumber || "-"}</ColumnValue>
        </Column>
        <Column>
          <ColumnTitle>Nationality</ColumnTitle>
          <ColumnValue>{candidate.nationality || "-"}</ColumnValue>
        </Column>
        <Column>
          <ColumnTitle>Driving License</ColumnTitle>
          <ColumnValue>
            {candidate.hasDrivingLicence ? "Yes" : "No"}
          </ColumnValue>
        </Column>
        <Column>
          <ColumnTitle>Location</ColumnTitle>
          <ColumnValue>{candidate.location || "-"}</ColumnValue>
        </Column>
        <Column>
          <ColumnTitle>Email address</ColumnTitle>
          <ColumnValue>{candidate.email || "-"}</ColumnValue>
        </Column>
      </Body>
    </Wrapper>
  );
};

type Props = {
  candidate: Candidate;
};

export default PersonalInfo;
